import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardMainService {
  constructor(private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (environment.dashboardPrefix === '/' + route.routeConfig.path) {
      return this.dashboardEnableCheck();
    }
  }

  dashboardEnableCheck() {
    if (environment.dashboardEnabled) {
      return true;
    }
    this.router.navigate(['/']);
  }
}
